import PlayGame from './Componentes/questionsList.js';
import './App.css';

function App() {
  return (
    <div className="App">
      <PlayGame/>
    </div>
  );
}

export default App;
